import React, { Component, Fragment } from 'react';
import PackBuilderCart from '../components/pack.builder.cart';
import PackBuilderOptions from './options/pack.builder.base.options';
import Typography from '@material-ui/core/Typography';

class PackBuilder extends Component {
  render() {
    const { 
      packData, 
      selectBaseOption, 
      selectAddOn, 
      removeBasePack, 
      removeBaseOption,
      removeAddOn  
    } = this.props;

    const { 
      selectedBasePack, 
      selectedBaseOptions, 
      selectedAddOns 
    } = this.props.packBuilder;

    return (
      <Fragment>
        <PackBuilderCart 
          selectedBasePack={selectedBasePack}
          selectedBaseOptions={selectedBaseOptions}
          selectedAddOns={selectedAddOns}
          removeBasePack={removeBasePack}
          removeBaseOption={removeBaseOption}
          removeAddOn={removeAddOn}
        />
        <Typography variant="h6">
          Base Pack Options
        </Typography>
        <PackBuilderOptions
          selectedBaseOptions={selectedBaseOptions}
          selectBaseOption={selectBaseOption}
          options={packData.basePackOptions} 
          optionType="BASE"/>
        <Typography variant="h6">
          Additional Pack Options
        </Typography>
        <PackBuilderOptions
          selectedAddOns={selectedAddOns}  
          selectAddOn={selectAddOn}
          options={packData.addOns} 
          optionType="ADDON"/>
    </Fragment>
    );
  }
}

export default (PackBuilder);